import React from 'react';
import { Col, Row } from 'react-bootstrap';

function attributeRow(label, attribute) {
  if (!attribute) return;
  return (
    <Row className="row-eq-height">
      <Col className="h5" xs={6}>
        {label}
      </Col>
      <Col xs={6}>
        {attribute}
      </Col>
    </Row>
  );
}

export default attributeRow;
